module.exports = "/cyber/_next/static/images/awards-786ebc832a754db5e5a6dbe7cb841c80.jpg";